// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__CqXNz","h2":"Card_h2__JbM4r","h3":"Card_h3__YrlO4","h4":"Card_h4__7LnPN"};